export default __webpack_public_path__ + "static/mobile-banner-b7dbb46de4b6d4d3b7e26a555dc73c02.png";